/**
 * Detects the presence of "healthfirst" in a string by normalizing the input.
 * It removes all non-alphabetic characters and ignores casing.
 * * @param {string} str - The input text to evaluate.
 * @returns {boolean} - Returns true if "healthfirst" is found after normalization.
 */
export const containsHealthFirst = (str: string) => {
  const cleanStr = str.replace(/[^a-zA-Z]/g, "").toLowerCase();
  return cleanStr.includes("healthfirst");
};
